export const SELECT_ALL_VALUE = 'Select All';
